import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // Include if using forms or ngModel
import { ToastrModule } from 'ngx-toastr'; // Include ToastrModule if using ToastrService
import { OilChangeSettingsComponent } from './oil-change-settings.component'; // Adjust the path as necessary
import { EmailManagerModule } from '../email-manager/email-manager.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    OilChangeSettingsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule, // Include if using forms or ngModel
    ToastrModule.forRoot(),
    EmailManagerModule,
    MatSlideToggleModule
  ],
  exports: [
    OilChangeSettingsComponent // Export OilChangeSettingsComponent if needed in other modules
  ]
})
export class OilChangeSettingsModule { }
